import { defineStore } from 'pinia'
import { services, getHeader, getUserInfo } from '@/assets/js/config.js'
import { BANK_STATUS } from '@/assets/js/status.js'
import axios from 'axios'
import {
	calculateInstallment,
	calculateLoanAmount,
	calculateClientNett,
	calculateBuyerDiscount,
	calculateCashback
} from '@/assets/js/calculator.js'
import { usePMPStore } from '@/stores/pmpStore'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import { useLookupStore } from '@/stores/lookupStore'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { useHestiaStore } from '@/stores/hestiaStore'
import { useMessagingStore } from '@/stores/messagingStore'

export const useProductStore = defineStore('productStore', {
	state: () => ({
		current_product_type: null,
		current_product_data: null,
		current_tab_type: null,
		products: [],
		master_products: [],
		refinance_details: null,
		submit_refinance: false,
		bank_list: [],
		selected_project: {},
		list_bank_statuses : [],
		list_mortgage_status : [],
		list_personal_loan_status : [],
		list_insurance_status : [],
		list_other_loan_status : [],
		list_mhlv_status : [],
    list_solicitor_status : [],
	}),
	getters: {
		//STATUSES
		list_sub_bank_status(){
			return this.list_bank_statuses
		},
		list_main_mortgage_status(){
			return this.list_mortgage_status.filter((item) => item.group === 'main')
		},
		list_sub_mortgage_status(){
			return this.list_mortgage_status.filter((item) => item.group === 'sub')
		},
		list_main_personal_loan_status(){
			return this.list_personal_loan_status.filter((item) => item.group === 'main')
		},
		list_sub_personal_loan_status(){
			return this.list_personal_loan_status.filter((item) => item.group === 'sub')
		},
		list_main_insurance_status(){
			return this.list_insurance_status.filter((item) => item.group === 'main')
		},
		list_sub_insurance_status(){
			return this.list_insurance_status.filter((item) => item.group === 'sub')
		},
		list_main_other_loan_status(){
			return this.list_other_loan_status.filter((item) => item.group === 'main')
		},
		list_sub_other_loan_status(){
			return this.list_other_loan_status.filter((item) => item.group === 'sub')
		},
		list_main_mhlv_status(){
			return this.list_mhlv_status.filter((item) => item.group === 'main')
		},
		list_sub_mhlv_status(){
			return this.list_mhlv_status.filter((item) => item.group === 'sub')
		},
    list_main_solicitor_status(){
			return this.list_solicitor_status.filter((item) => item.group === 'main')
		},
		list_sub_solicitor_status(){
			return this.list_solicitor_status.filter((item) => item.group === 'sub')
		},
		//PRODUCTS
		refinance_real_products(state) {
			return state.products.filter((product) => product.prod_type === 'refinance' && product.prod_main_status !== 'Draft')
		},
		refinance_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'refinance' && product.prod_main_status === 'Draft')
		},
		insurance_real_products(state) {
			return state.products.filter((product) => product.prod_type === 'insurance' && product.prod_main_status !== 'Draft')
		},
		insurance_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'insurance' && product.prod_main_status === 'Draft')
		},
		other_real_products(state) {
			return state.products.filter((product) => product.prod_type === 'other' && product.prod_main_status !== 'Draft')
		},
		other_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'other' && product.prod_main_status === 'Draft')
		},
		mhlv_real_products(state) {
			return state.products.filter((product) => product.prod_type === 'mhlv' && product.prod_main_status !== 'Draft')
		},
		mhlv_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'mhlv' && product.prod_main_status === 'Draft')
		},
		solicitor_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'solicitor' && product.prod_main_status === 'Draft')
		},
		personal_loan_real_products(state) {
			return state.products.filter((product) => product.prod_type === 'personal_loan' && product.prod_main_status !== 'Draft')
		},
		personal_loan_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'personal_loan' && product.prod_main_status === 'Draft')
		},
		mortgage_real_products(state) {
			return state.products.filter((product) => product.prod_type === 'mortgage' && product.prod_main_status !== 'Draft')
		},
		mortgage_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'mortgage' && product.prod_main_status === 'Draft')
		},
		property_draft_products(state) {
			return state.products.filter((product) => product.prod_type === 'property' && product.prod_main_status === 'Draft')
		},
		real_property_products(state) {
			return state.products.filter((product) => product.prod_type === 'property' && product.prod_main_status !== 'Draft')
		},
		draft_products(state) {
			return state.products.filter((product) => product.prod_main_status === 'Draft')
		},
		real_products(state) {
			return state.products.filter((product) => product.prod_main_status !== 'Draft')
		},

		// master
		master_property_products(state) {
			return state.master_products.filter((product) => product.prod_type === 'property' && product.prod_main_status !== 'Draft')
		},
		master_mortgage_products(state) {
			return state.master_products.filter((product) => product.prod_type === 'mortgage' && product.prod_main_status !== 'Draft')
		},
		master_personal_loan_products(state) {
			return state.master_products.filter((product) => product.prod_type === 'personal_loan' && product.prod_main_status !== 'Draft')
		},
		master_refinance_products(state) {
			return state.master_products.filter((product) => product.prod_type === 'refinance' && product.prod_main_status !== 'Draft')
		},
	},
	actions: {
		initConstant(){
			this.getCaseStatusList('status-bank',{},'no_paginate').then(resp => {
				this.list_bank_statuses = _gHlp.getValue(resp,'data');
			});
			this.getCaseStatusList('status-mortgage',{},'no_paginate').then(resp => {
				this.list_mortgage_status = _gHlp.getValue(resp,'data');
			});
			this.getCaseStatusList('status-personal-loan',{},'no_paginate').then(resp => {
				this.list_personal_loan_status = _gHlp.getValue(resp,'data');
			});
			this.getCaseStatusList('status-insurance',{},'no_paginate').then(resp => {
				this.list_insurance_status = _gHlp.getValue(resp,'data');
			});
			this.getCaseStatusList('status-other-loan',{},'no_paginate').then(resp => {
				this.list_other_loan_status = _gHlp.getValue(resp,'data');
			});
      this.getCaseStatusList('status-solicitor',{},'no_paginate').then(resp => {
				this.list_solicitor_status = _gHlp.getValue(resp,'data');
			});
      this.getCaseStatusList('status-mhlv',{},'no_paginate').then(resp => {
				this.list_mhlv_status = _gHlp.getValue(resp,'data');
			});
		},
		getCaseStatusList(endpoint, filters={}, paginate=null){
			return new Promise((resolve, reject) => {
				const params = _gHlp.generateQueryParams({
					search:{...filters},
					paginate: paginate
				})
				axios.get(services.product + endpoint + '?'+params, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				});
			})
		},
		createCaseStatus(endpoint, formData){
			return new Promise((resolve, reject) => {
				axios.post(services.product + endpoint, formData, { headers: getHeader() }).then(resp => {
					console.log(resp)
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				});
			})
		},
		updateCaseStatus(endpoint, id, formData){
			return new Promise((resolve, reject) => {
				axios.put(services.product + endpoint + '/' + id, formData, { headers: getHeader() }).then(resp => {
					console.log(resp)
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				});
			})
		},
		deleteCaseStatus(endpoint, id){
			return new Promise((resolve, reject) => {
				axios.delete(services.product + endpoint + '/'+id, { headers: getHeader() }).then(resp => {
					resolve(_gHlp.getValue(resp,'data',[]));
				}).catch(err => {
					reject(err);
				});
			})
		},
		setCurrentTab(tab) {
			this.current_tab_type = tab
		},
		resetProductStore() {
			this.current_product_type = null,
				this.current_product_data = null,
				this.products = []
		},
		clearSelectedProperty() {
			this.selected_project = {}
		},
		setProducts(value) {
			this.products = value
		},
		setSelectedProperty(property) {
			if (property.project_source_type === 'HESTIA') {
				const params = {
					owner_id: property.project_id,
					owner_type: 'project'
				}
				axios.get(services.attachment + 'attachments', {
					headers: getHeader(),
					params: params
				})
					.then(res => {
						// console.log(res.data.data)
						res.data.data.forEach(item => {
							if (item.ext.toLowerCase() === 'pdf') {
								this.selected_project.project_files.push(item)
							} else if (item.attachment_category_id === 19) {
								this.selected_project.project_cover_image = item.url
							}
						})
					})
					.catch(e => {
						this.errorFunction(e)
					})
			}

			this.selected_project = property
		},
		async getProducts(objParams = {}) {
			let queryParams = _gHlp.generateQueryParams({ ...{ version: 2, page: 1, paginate: 25 }, ...objParams });
			return new Promise((resolve, reject) => {
				axios.get(`${services.product}products?${queryParams}`, { headers: getHeader() }).then((res) => {
					resolve(res.data);
				}).catch((err) => {
					reject(err);
				})
			});
		},
		async getProduct(prod_id) {
			return new Promise((resolve, reject) => {
				let queryParams = _gHlp.generateQueryParams({ prod_id: prod_id });
				axios.get(`${services.product}product/detail?${queryParams}`, { headers: getHeader() }).then((res) => {
					resolve(res.data);
				}).catch((err) => {
					reject(err);
				})
			})
		},
		async getCustomerProducts(customer_id) {
			try {
				let urlSearchParams = new URLSearchParams()
				urlSearchParams.append('is_full_content', true)
				urlSearchParams.append('pagination[limit]', 0)
				urlSearchParams.append('pagination[order][prod_id]', 'DESC')
				urlSearchParams.append('search[prod_customer_id]', customer_id)
				const res = await axios.get(`${services.product}products?${urlSearchParams.toString()}`, { headers: getHeader() })
				this.products = res.data.content
			} catch (e) {
				this.products = []
				console.log('Product Store (getCustomerProducts) failed:' + e)
			}
		},
		async removeProduct(product) {
			try {
				const res = await axios.post(services.product + 'product/delete/' + product.prod_id, null, { headers: getHeader() })
				this.getCustomerProducts(product.prod_customer_id)
			} catch (e) {
				console.log('Product Store (removeProduct) failed:' + e)
				throw e
			}
		},
		async convertProductToCase(id, type = null) {
			const product = this.products.find(product => product.prod_id == id)

			if (!product) {
				throw 'Draft not found.'
			}

			try {
				let updatedData = {
					...product,
					prod_main_status: 'Application Pending',
					prod_status: 'Application Pending',
				}

				// check if property product and check if can create the case on PMP
				if (product.prod_type === 'property' && product.product_detail.prod_pm_property_src != 'HESTIA') {
					await usePMPStore().checkCanCreatePMPCase(product.prod_customer_id, product.product_detail.prod_pm_unit_id)
				}

				// check if app code is sas, make approval
				// if (_gAuth.isAppConsfield()) {
				// 	const productRes = await axios.post(services.product + 'product/' + id, updatedData, { headers: getHeader() })
				// 	if (type === 'property') {
				// 		const pmpCreateCaseApprovalRes = await usePMPStore().createCaseApproval(id)
				// 	}
				// } else {
				// 	// if not sas, create the product without approval
				// 	let product_status = null
				// 	switch (product.prod_type) {
				// 		case 'property':
				// 			product_status = null
				// 			break;
				// 		case 'mortgage':
				// 			product_status = null
				// 			break;
				// 		case 'personal_loan':
				// 			product_status = null
				// 			break;
				// 		case 'insurance':
				// 			product_status = null
				// 			break;
				// 		case 'refinance':
				// 			product_status = null
				// 			break;
				// 		case 'other':
				// 			product_status = null
				// 			break;
				// 		case 'solicitor':
				// 			product_status = null
				// 			break;
				// 		case 'mhlv':
				// 			product_status = null
				// 			break;
				// 		default:
				// 			throw "Product type not found"
				// 	}

					// updatedData = {
					// 	...product,
					// 	prod_main_status: product_status,
					// 	prod_status: product_status,
					// }
					if (product.prod_type === 'property' && product.product_detail.prod_pm_property_src != 'HESTIA') {
						const pmpCreateCaseRes = await usePMPStore().syncV2CaseToPMP(id)
					}
					else if (product.prod_type === 'property' && product.product_detail.prod_pm_property_src == 'HESTIA') {
						const hestiaUpdateUnit = await useHestiaStore().updateHestiaUnitStatus(product.product_detail.prod_pm_unit_id)
					}
					const productRes = await axios.post(services.product + 'product/' + id, updatedData, { headers: getHeader() })

				// }

				this.getCustomerProducts(product.prod_customer_id)
			} catch (e) {
				console.log('Product Store (convertProductToCase) failed:' + e)
				throw e
			}
		},
		async addPropertyProductBank(id, bank, is_own = false) {
			try {
				const product = this.products.find(product => product.prod_id == id)
				if (!product) {
					throw 'Case not found.'
				}

				// if using own values, then override default calculation
				var bankData = {}
				if (is_own) {
					let spa_amount = bank.prod_bnk_spa_amount
					let loan_margin = bank.prod_bnk_margin
					let loan_amount = bank.prod_bnk_loan_amount
					let installment = bank.prod_bnk_installment

					bankData = {
						"prod_bnk_prod_id": id,
						"prod_bnk_name": bank.prod_bnk_name,
						"prod_bnk_logo_url": bank.prod_bnk_logo_url,
						"prod_bnk_banker_id": bank.prod_bnk_banker_id ?? null,
						"prod_bnk_stage_status": "Pending Submission",
						"prod_bnk_loan_amount": loan_amount,
						"prod_bnk_spa_amount": spa_amount,
						"prod_bnk_interest": bank.prod_bnk_interest,
						"prod_bnk_margin": loan_margin,
						"prod_bnk_tenure": bank.prod_bnk_tenure,
						"prod_bnk_gross_cashback": null,
						"prod_bnk_installment": installment,
						"prod_bnk_code": bank.prod_bnk_code,
						"prod_bnk_add_cost": bank.prod_bnk_add_cost
					}
				} else {
					let spa_amount = product.product_detail.prod_pm_spa_price
					let loan_margin = 90
					let loan_amount = calculateLoanAmount(spa_amount, loan_margin)
					let installment = calculateInstallment(loan_amount, bank.bank_loan_interest_rate, bank.bank_loan_tenure_year)

					bankData = {
						"prod_bnk_prod_id": id,
						"prod_bnk_name": bank.bank_name,
						"prod_bnk_logo_url": bank.bank_image_url,
						"prod_bnk_banker_id": null,
						"prod_bnk_stage_status": "Pending Submission",
						"prod_bnk_loan_amount": loan_amount,
						"prod_bnk_spa_amount": spa_amount,
						"prod_bnk_interest": bank.bank_loan_interest_rate,
						"prod_bnk_margin": loan_margin,
						"prod_bnk_tenure": bank.bank_loan_tenure_year,
						"prod_bnk_gross_cashback": null,
						"prod_bnk_installment": installment,
						"prod_bnk_code": bank.bank_code,
						"prod_bnk_add_cost": bank.prod_bnk_add_cost
					}
				}

				const res = await axios.post(services.product + 'product-bank', bankData, { headers: getHeader() })
				if (product.prod_main_status !== 'Draft' && product.prod_type === 'property') {
					const pmpRes = await usePMPStore().syncV2CaseToPMP(id)
				}
				this.getCustomerProducts(product.prod_customer_id)
			} catch (e) {
				console.log('Product Store (addPropertyProductBank) failed:' + e)
				throw e
			}
		},
		async updatePropertyProductBank(bank, refresh = true) {
			try {
				const product = this.products.find(product => product.prod_id == bank.prod_bnk_prod_id)
				if (!product) {
					throw 'Case not found.'
				}
				const spa_amount = bank.prod_bnk_spa_amount
				const loan_margin = bank.prod_bnk_margin
				const loan_amount = calculateLoanAmount(spa_amount, loan_margin)
				const installment = calculateInstallment(loan_amount, bank.prod_bnk_interest, bank.prod_bnk_tenure)

				// check if trying to change status other than pending submission but not yet submit bank
				if (bank.prod_bnk_stage_status !== 'Pending Submission' && !bank.prod_bnk_submission_date) {
					throw 'Please submit the bank first.'
				}

				let bankData = {
					"prod_bnk_prod_id": bank.prod_bnk_prod_id,
					"prod_bnk_name": bank.prod_bnk_name,
					"prod_bnk_logo_url": bank.prod_bnk_logo_url,
					"prod_bnk_stage_status": bank.prod_bnk_stage_status,
					"prod_bnk_banker_id": bank.prod_bnk_banker_id ?? null,
					"prod_bnk_loan_amount": loan_amount,
					"prod_bnk_spa_amount": spa_amount,
					"prod_bnk_interest": bank.prod_bnk_interest,
					"prod_bnk_margin": loan_margin,
					"prod_bnk_tenure": bank.prod_bnk_tenure,
					"prod_bnk_gross_cashback": null,
					"prod_bnk_installment": installment,
					"prod_bnk_code": bank.prod_bnk_code,
					"prod_bnk_approved_date": bank.prod_bnk_approved_date ?? null,
					"prod_bnk_submission_date": bank.prod_bnk_submission_date
				}

				// check if status is lo sign, only one time update
				if (bank.prod_bnk_stage_status === 'L.O acceptance by client' && !bank.prod_bnk_lo_sign_date) {
					bankData = {
						...bankData,
						"prod_bnk_lo_sign_date": _gHlp.getCurrentDateTime()
					}
				}

				const res = await axios.post(services.product + 'product-bank/' + bank.prod_bnk_id, bankData, { headers: getHeader() })
				if (product.prod_main_status !== 'Draft' && product.prod_type === 'property') {
					const pmpRes = await usePMPStore().syncV2CaseToPMP(product.prod_id)
				}
				if (refresh) {
					this.getCustomerProducts(product.prod_customer_id)
				}
			} catch (e) {
				console.log('Product Store (updatePropertyProduct) failed:' + e)
				throw e
			}
		},
		async removePropertyProductBank(bank) {
			const product = this.products.find(product => product.prod_id == bank.prod_bnk_prod_id)
			if (!product) {
				throw 'Case not found.'
			}
			try {
				const res = await axios.post(services.product + 'product-bank/delete/' + bank.prod_bnk_id, null, { headers: getHeader() })
				if (product.prod_main_status !== 'Draft' && product.prod_type === 'property' && product.product_detail.prod_pm_property_src != "HESTIA") {
					const pmpRes = await usePMPStore().syncV2CaseToPMP(bank.prod_bnk_prod_id)
				}
				this.getCustomerProducts(product.prod_customer_id)
			} catch (e) {
				console.log('Product Store (removePropertyProductBank) failed:' + e)
				throw e
			}
		},
		async getBankersBasedOnBank(userBankerList, bank_code, product_type = null) {
			try {
				let banker = userBankerList.filter((item) => (item.banks.some(pBank => pBank.bank_code.toLowerCase() === bank_code.toLowerCase())));
				if (product_type == 'property') {
					banker = userBankerList.filter((item) => (item.banks.some(pBank => ((pBank.bank_code.toLowerCase() === bank_code.toLowerCase()) && (pBank.is_banker_property == 1)))));
				} else if (product_type == 'mortgage') {
					banker = userBankerList.filter((item) => (item.banks.some(pBank => ((pBank.bank_code.toLowerCase() === bank_code.toLowerCase()) && (pBank.is_banker_mortgage == 1)))));
				} else if (product_type == 'personal_loan') {
					banker = userBankerList.filter((item) => (item.banks.some(pBank => ((pBank.bank_code.toLowerCase() === bank_code.toLowerCase()) && (pBank.is_banker_personal == 1)))));
				} else if (product_type == 'refinance') {
					banker = userBankerList.filter((item) => (item.banks.some(pBank => ((pBank.bank_code.toLowerCase() === bank_code.toLowerCase()) && (pBank.is_banker_refinance == 1)))));
				} else if (product_type == 'insurance') {
					banker = userBankerList.filter((item) => (item.banks.some(pBank => ((pBank.bank_code.toLowerCase() === bank_code.toLowerCase()) && (pBank.is_banker_insurance == 1)))));
				} else if (product_type == 'other') {
					banker = userBankerList.filter((item) => (item.banks.some(pBank => ((pBank.bank_code.toLowerCase() === bank_code.toLowerCase()) && (pBank.is_banker_other == 1)))));
				}
				console.log(userBankerList)
				console.log(banker)
				console.log(product_type)
				return banker;
			} catch (e) {
				return [];
			}
		},
		async updatePropertyProductBankStatus(bank, status, is_update_submission = false) {
			try {
				const product = this.products.find(product => product.prod_id == bank.prod_bnk_prod_id)
				if (!product) {
					throw 'Case not found.'
				}

				// if bank already submitted, use current val
				let submission_date = _gHlp.getCurrentDateTime()
				if (bank.prod_bnk_submission_date) {
					submission_date = bank.prod_bnk_submission_date
				}

				let bankData = {
					...bank,
					prod_bnk_stage_status: bank.prod_bnk_submission_date ? bank.prod_bnk_stage_status : status,
					prod_bnk_submission_date: is_update_submission ? submission_date : bank.prod_bnk_submission_date
				}

				const res = await axios.post(services.product + 'product-bank/' + bank.prod_bnk_id, bankData, { headers: getHeader() })
				if (product.prod_main_status !== 'Draft' && product.prod_type === 'property' && product.product_detail.prod_pm_property_src != "HESTIA") {
					const pmpRes = await usePMPStore().syncV2CaseToPMP(product.prod_id)
				}
				this.getCustomerProducts(product.prod_customer_id)
			} catch (e) {
				console.log('Product Store (updatePropertyProduct) failed:' + e)
				throw e
			}
		},
		async createPropertyProduct() {
			const banks = this.current_product_data.banks;
			const project = this.current_product_data.project;
			const unit = this.current_product_data.unit;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user


			if (!banks || !project || !unit || !current_customer) {
				throw 'Some data is missing.';
			}

			// set product banks detail
			let product_banks = []
			banks.forEach((bank) => {
				let spa_amount = unit.unit_price
				let loan_margin = 90
				let loan_amount = calculateLoanAmount(spa_amount, loan_margin)
				let installment;
				if (bank.bank_code === "CASH_BUYER") {
					installment = 0;
				} else {
					installment = calculateInstallment(loan_amount, bank.bank_loan_interest_rate, bank.bank_loan_tenure_year);
				}

				product_banks.push({
					"prod_bnk_name": bank.bank_name,
					"prod_bnk_logo_url": bank.bank_image_url,
					"prod_bnk_banker_id": null,
					"prod_bnk_stage_status": null,
					"prod_bnk_loan_amount": loan_amount,
					"prod_bnk_spa_amount": spa_amount,
					"prod_bnk_interest": bank.bank_loan_interest_rate,
					"prod_bnk_margin": loan_margin,
					"prod_bnk_tenure": bank.bank_loan_tenure_year,
					"prod_bnk_gross_cashback": null,
					"prod_bnk_installment": installment,
					"prod_bnk_code": bank.bank_code,
				})
			})
			// set product data details
			const nett_buyer_discount = calculateClientNett(product_banks[0].prod_bnk_spa_amount, unit.settings.cb_percent_to_customer)
			const buyer_discount_percent = calculateBuyerDiscount(nett_buyer_discount, product_banks[0].prod_bnk_spa_amount)
			const cashback = calculateCashback(product_banks[0].prod_bnk_loan_amount, nett_buyer_discount)

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "property",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": project.project_cover_image,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_project-customer_' + current_customer.customer_id,
				"prod_payment_method": null,
				"prod_booking_content": null,
				"product_detail": {
					"prod_pm_property_id": project.project_id,
					"prod_pm_project_name": project.project_name,
					"prod_pm_property_type": project.project_type,
					"prod_pm_lease_type": project.project_lease_type_id === 1 ? 'Freehold' : 'Leasehold',
					"prod_pm_property_size": unit.built_up,
					"prod_pm_benefits": null,
					"prod_pm_unit_id": unit.unitno_id,
					"prod_pm_property_src": project.project_source_type ? project.project_source_type : 'PMP',
					"prod_pm_unit_no": unit.unit_no,
					"prod_pm_spa_price": unit.unit_price,
					"prod_pm_net_buyer_discount": nett_buyer_discount,
					"prod_pm_buyer_discount": buyer_discount_percent,
					"prod_pm_cashback": cashback,
					"prod_pm_sp_agreement_fee": unit.unit_fees.unit_fees_sp_agreement,
					"prod_pm_mot_fees": unit.unit_fees.unit_fees_mot,
					"prod_pm_total_fees": unit.unit_fees.unit_fees_total,
					"prod_pm_loan_agreement_fees": unit.unit_fees.unit_fees_loan_agreement,
					"prod_pm_maintenance_fees": unit.unit_fees.unit_fees_maintenance,
					"prod_pm_loan_stamp_duty": unit.unit_fees.unit_fees_loan_stamp_duty,
					"prod_pm_sinking_fund": unit.unit_fees.unit_fees_sinking_fund,
					"prod_pm_unit_sale_type": unit.sale_type,
				},
				"product_banks": product_banks
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.banks;
				delete this.current_product_data.project;
				delete this.current_product_data.unit;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createPropertyProduct) failed:' + e)
				throw e
			}
		},
		async createMortgageProduct() {
			const banks = this.current_product_data.banks;
			const mortgage = this.current_product_data.mortgage;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user
			const bank = banks[0]
			if (!banks || !mortgage || !current_customer) {
				throw 'Some data is missing.';
			}

			// set product detail
			let product_banks = [
				{
					"prod_bnk_name": bank.bank_name,
					"prod_bnk_logo_url": bank.bank_image_url,
					"prod_bnk_banker_id": null,
					"prod_bnk_stage_status": null,
					"prod_bnk_loan_amount": mortgage.mortgage_loan_amount,
					"prod_bnk_spa_amount": mortgage.mortgage_spa_price,
					"prod_bnk_interest": mortgage.mortgage_interest_rate,
					"prod_bnk_margin": mortgage.mortgage_loan_margin,
					"prod_bnk_tenure": mortgage.mortgage_tenure_year,
					"prod_bnk_gross_cashback": null,
					"prod_bnk_installment": mortgage.mortgage_installment,
					"prod_bnk_code": bank.bank_code,
					"prod_bnk_agreement_rate": mortgage.mortgage_arrangement_fee,
					"prod_bnk_agreement_rate_sst": mortgage.mortgage_arrangement_sst_fee,
					"prod_bnk_agreement_fees": mortgage.mortgage_arrangement_amount,
				}
			]

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "mortgage",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_mortgage-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_pm_project_name": mortgage.mortgage_project_name,
					"prod_pm_unit_no": mortgage.mortgage_unit_no,
					"prod_pm_property_type": mortgage.mortgage_type,
					// "prod_pm_loan_agreement_fees": mortgage.mortgage_arragement_amount,
					// "prod_pm_loan_agreement_rate": mortgage.mortgage_arragement_fee,
					// "prod_pm_loan_agreement_rate_sst": mortgage.mortgage_arragement_sst_fee
				},
				"product_banks": product_banks
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.banks;
				delete this.current_product_data.mortgage;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createMortgageProduct) failed:' + e)
				throw e
			}
		},
		async createPersonalLoanProduct() {
			const banks = this.current_product_data.banks;
			const personal_loan = this.current_product_data.personal_loan;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user
			const bank = banks[0]

			if (!banks || !personal_loan || !current_customer) {
				throw 'Some data is missing.';
			}

			// set product detail
			let product_banks = [
				{
					"prod_bnk_name": bank.bank_name,
					"prod_bnk_logo_url": bank.bank_image_url,
					"prod_bnk_banker_id": null,
					"prod_bnk_stage_status": null,
					"prod_bnk_loan_amount": personal_loan.personal_loan_loan_amount,
					"prod_bnk_interest": personal_loan.personal_loan_interest_rate,
					"prod_bnk_tenure": personal_loan.personal_loan_tenure_year,
					"prod_bnk_gross_cashback": null,
					"prod_bnk_installment": personal_loan.personal_loan_installment,
					"prod_bnk_code": bank.bank_code,
					"prod_bnk_agreement_rate": personal_loan.personal_loan_arragement_fee,
					"prod_bnk_agreement_rate_sst": personal_loan.personal_loan_arragement_sst_fee,
					"prod_bnk_agreement_fees": personal_loan.personal_loan_arragement_amount,
				}
			]

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "personal_loan",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_personal_loan-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_pl_stage_status": "Pending",
					"prod_pl_loan_amount": personal_loan.personal_loan_loan_amount,
					"prod_pl_interest": personal_loan.personal_loan_interest_rate,
					"prod_pl_tenure": personal_loan.personal_loan_tenure_year,
					"prod_pl_installment": personal_loan.personal_loan_installment,
					// "prod_pl_loan_agreement_fees": personal_loan.personal_loan_arragement_amount,
					// "prod_pl_loan_agreement_rate": personal_loan.personal_loan_arragement_fee,
					// "prod_pl_loan_agreement_rate_sst": personal_loan.personal_loan_arragement_sst_fee
				},
				"product_banks": product_banks
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.banks;
				delete this.current_product_data.personal_loan;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createPersonalLoanProduct) failed:' + e)
				throw e
			}
		},
		async createInsuranceProduct() {
			const insurance = this.current_product_data.insurance;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user

			if (!insurance || !current_customer) {
				throw 'Some data is missing.';
			}

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "insurance",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_insurance-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_ins_type": insurance.prod_ins_type,
					"prod_ins_package": insurance.prod_ins_package,
					"prod_ins_company": insurance.prod_ins_company,
					"prod_ins_premium_pa": insurance.prod_ins_premium_pa,
					"prod_ins_premium_pm": insurance.prod_ins_premium_pm,
					"prod_ins_premium_cover": insurance.prod_ins_premium_cover,
					"prod_ins_paid_by": insurance.prod_ins_paid_by
				},
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.insurance;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createInsuranceProduct) failed:' + e)
				throw e
			}
		},
		async createOtherLoanProduct() {
			const other_loan = this.current_product_data.other_loan;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user

			if (!other_loan || !current_customer) {
				throw 'Some data is missing.';
			}

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "other",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_other-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_oth_type": other_loan.prod_oth_type,
					"prod_oth_detail": other_loan.prod_oth_detail,
					"prod_oth_value": other_loan.prod_oth_value,
					"prod_oth_pay_mode": other_loan.prod_oth_pay_mode,
					"prod_oth_agreement_rate": other_loan.prod_oth_agreement_rate,
					"prod_oth_agreement_rate_sst": other_loan.prod_oth_agreement_rate_sst,
					"prod_oth_agreement_fees": other_loan.prod_oth_agreement_fees
				},
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.other_loan;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createInsuranceProduct) failed:' + e)
				throw e
			}
		},
		async createMhlvProduct() {
			const mhlv = this.current_product_data.mhlv;
			const current_customer = this.current_product_data.current_customer

			if (!mhlv || !current_customer) {
				throw 'Some data is missing.';
			}

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "mhlv",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_other-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_mhlv_loan_type": mhlv.prod_mhlv_loan_type,
					"prod_mhlv_loan_amount": mhlv.prod_mhlv_loan_amount,
					"prod_mhlv_interest_rate": mhlv.prod_mhlv_interest_rate,
					"prod_mhlv_tenure": mhlv.prod_mhlv_tenure,
					"prod_mhlv_installment": mhlv.prod_mhlv_installment,
					"prod_mhlv_agreement_amt": mhlv.prod_mhlv_agreement_amt,
					"prod_mhlv_agreement_rate_sst": mhlv.prod_mhlv_agreement_rate_sst,
					"prod_mhlv_agreement_fees": mhlv.prod_mhlv_agreement_fees,
				},
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.mhlv;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createInsuranceProduct) failed:' + e)
				throw e
			}
		},
		async createRefinanceProduct() {
			const banks = this.current_product_data.banks;
			const refinance = this.current_product_data.refinance;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user
			const bank = banks[0]

			if (!banks || !refinance || !current_customer) {
				throw 'Some data is missing.';
			}

			// set product detail
			let product_banks = [
				{
					"prod_bnk_name": bank.bank_name,
					"prod_bnk_logo_url": bank.bank_image_url,
					"prod_bnk_banker_id": null,
					"prod_bnk_stage_status": null,
					"prod_bnk_loan_amount": refinance.refinance_loan_amount,
					"prod_bnk_interest": refinance.refinance_interest_rate,
					"prod_bnk_margin": refinance.refinance_loan_margin,
					"prod_bnk_tenure": refinance.refinance_tenure_year,
					"prod_bnk_gross_cashback": null,
					"prod_bnk_installment": refinance.refinance_installment,
					"prod_bnk_code": bank.bank_code,
					"prod_bnk_agreement_rate": refinance.refinance_arragement_fee,
					"prod_bnk_agreement_rate_sst": refinance.refinance_arragement_sst_fee,
					"prod_bnk_agreement_fees": refinance.refinance_arragement_amount,
				}
			]

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "refinance",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_refinance-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_ref_stage_status": "Pending",
					"prod_ref_remortgage_amount": refinance.refinance_remortgage_amount,
					"prod_ref_project_name": refinance.refinance_project_name,
					"prod_ref_loan_amount": refinance.refinance_loan_amount,
					"prod_ref_margin": refinance.refinance_loan_margin,
					"prod_ref_interest": refinance.refinance_interest_rate,
					"prod_ref_tenure": refinance.refinance_tenure_year,
					"prod_ref_installment": refinance.refinance_installment,
					"prod_ref_bank_outstanding": refinance.refinance_bank_outstanding,
					"prod_ref_cashout_amount": refinance.refinance_cashout_amount,
					// "prod_ref_agreement_fees": refinance.refinance_arragement_amount,
					// "prod_ref_agreement_rate": refinance.refinance_arragement_fee,
					// "prod_ref_agreement_rate_sst": refinance.refinance_arragement_sst_fee
				},
				"product_banks": product_banks
			}

			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.banks;
				delete this.current_product_data.refinance;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createRefinanceProduct) failed:' + e)
				throw e
			}
		},
		async createSolicitorProduct() {
			const solicitor = this.current_product_data.solicitor;
			const current_customer = this.current_product_data.current_customer
			const auth_user = useAuthStore().auth_user

			if (!solicitor || !current_customer) {
				throw 'Some data is missing.';
			}

			let productData = {
				"prod_customer_id": current_customer.customer_id,
				"prod_case_no": null,
				"prod_customer_name": current_customer.name,
				"prod_customer_basket": current_customer.basket.basket_color,
				"prod_type": "solicitor",
				"prod_lead_type": current_customer.type,
				"prod_agent_id": current_customer.se.id,
				"prod_agent_username": current_customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Draft",
				"prod_status": "Draft",
				"prod_platform_id": current_customer.platform ? current_customer.platform.platform_id : null,
				"prod_channel_id": current_customer.channel ? current_customer.channel.channel_id : null,
				"prod_total_sales": null,
				"prod_image_url": null,
				"prod_bnk_submission_date": null,
				"prod_acceptance_date": null,
				"prod_custom_identifier": 'case_solicitor-customer_' + current_customer.customer_id,
				"product_detail": {
					"prod_sol_type": solicitor.prod_sol_type,
					"prod_sol_spa_amount": solicitor.prod_sol_spa_amount,
					"prod_sol_loan_margin": solicitor.prod_sol_loan_margin,
					"prod_sol_bnk_name": solicitor.prod_sol_bnk_name,
					"prod_sol_title_type": solicitor.prod_sol_title_type,
					"prod_sol_land_type": solicitor.prod_sol_land_type,
					"prod_sol_property_type": solicitor.prod_sol_property_type,
					"prod_sol_melay_reserve": solicitor.prod_sol_melay_reserve,
					"prod_sol_joint_name": solicitor.prod_sol_joint_name,
					"prod_sol_joint_no": solicitor.prod_sol_joint_no,
					"prod_sol_first_home": solicitor.prod_sol_first_home,
					"prod_sol_firm": solicitor.prod_sol_firm,
					"prod_sol_firm_id": solicitor.prod_sol_firm_id,
					"prod_sol_loan_type": solicitor.prod_sol_loan_type,
					"prod_sol_prod_type_subject": solicitor.prod_sol_prod_type_subject
				},
			}
			try {
				const res = await axios.post(services.product + 'product', productData, { headers: getHeader() })
				delete this.current_product_data.solicitor;
				this.getCustomerProducts(current_customer.customer_id)
			} catch (e) {
				console.log('Product Store (createSolicitorProduct) failed:' + e)
				throw e
			}
		},
		async updateProduct(id, params) {
			return await axios.post(services.product + 'product/' + id, params, { headers: getHeader() })
				.then(res => {
					_gNotif.notifySuccess('<b>Product</b> - Successfully Updated.')
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
		},
		async getBankList() {
			try {
				const res = await axios.post(services.lookup + 'tables', { tables: 'banks' }, { headers: getHeader() })
				this.bank_list = res.data.data.banks
			} catch (e) {
				console.log('Product Store (getBankList) failed:' + e)
				throw e
			}
		},
		reMappingMainStatusForProperty(banks) {
			if (_gHlp.isEmpty(banks)) return null;
			let total = banks.length;

			let currLevel = 0;
			let cancelLevel = 0;
			let haveCancel = 0;
			for (var idx = 0; idx < banks.length; idx++) {
				let bnk = banks[idx];
				let sts = bnk.prod_bnk_stage_status;
				let x = BANK_STATUS.find((data) => (data.value == sts));

				if (!_gHlp.isEmpty(x)) {
					let lvl = x.lvl;
					//IF NOT DECLINED, REJECTED, CANCELED
					if ([9, 10, 11].includes(lvl)) {
						if (lvl > cancelLevel) {
							cancelLevel = lvl;
						}
						haveCancel++;
					} else {
						if (lvl > currLevel) {
							currLevel = lvl;
						}
					}
				}
			}

			if (haveCancel == total && total > 0) {
				currLevel = cancelLevel
			}

			if ([1, 2, 3, 4, 19, 20, 21].includes(currLevel)) {
				return 'Reserve';
			} else if ([5, 6, 7, 8].includes(currLevel)) {
				return 'Bank Processing';
			} else if ([9].includes(currLevel)) {
				return 'Revoke';
			} else if ([10, 11].includes(currLevel)) {
				return 'Cancelled';
			} else if ([12].includes(currLevel)) {
				return 'Bank Approval';
			} else if ([13, 14, 15].includes(currLevel)) {
				return 'Lawyer Processing';
			} else if ([16, 17].includes(currLevel)) {
				return 'SOLD';
			} else if ([18].includes(currLevel)) {
				return 'Completed';
			} else {
				return null;
			}
		},
		async generateProductCommission(product) {
			const res = await axios.get(services.product + 'product/get-content-commission/' + product.prod_id, { headers: getHeader() })
			if (!_gHlp.isEmpty(res.data)) {
				caseEventBus.$emit('show-confirm-commission-modal', res.data);
			} else {
				_gNotif.notifyError('This Product Commission Not Available')
			}
		},
		checkGenerateCommission(product, table_status, selected_status) {
			if (!_gHlp.isEmpty(product.prod_commission_at)) {
				_gNotif.notifyError('<b>This commission already generated</b> - Please remember to sync it on commission system.')
			}
			if (_gHlp.isEmpty(product) || !_gHlp.isEmpty(product.prod_commission_at) || _gHlp.isEmpty(table_status) || _gHlp.isEmpty(selected_status)) return false;
			//EXCLUDE FROM COMMISSION
			if (!(['mortgage', 'property'].includes(product.prod_type))) return false;
			let status = null;
			let product_type = product.prod_type;
			if (product_type == 'property') {
				status = this.list_bank_statuses.find((item) => (item.bank_status_name == selected_status && item.is_generate_commission == 1));
			} else if (product_type == 'mortgage') {
				status = this.list_mortgage_status.find((item) => (item.status == selected_status && item.is_generate_commission == 1));
			} else if (product_type == 'personal_loan') {
				status = this.list_personal_loan_status.find((item) => (item.status == selected_status && item.is_generate_commission == 1));
			} else if (product_type == 'refinance') {
				status = this.list_mortgage_status.find((item) => (item.status == selected_status && item.is_generate_commission == 1));
			} else if (product_type == 'insurance') {
				status = this.list_insurance_status.find((item) => (item.status == selected_status && item.is_generate_commission == 1));
			} else if (product_type == 'other') {
				status = this.list_other_loan_status.find((item) => (item.status == selected_status && item.is_generate_commission == 1));
			}
			if (_gHlp.isEmpty(status)) return false;

			this.generateProductCommission(product);
		},
		checkCanGenerateCommision(product) {
			return false //TEMPORARY DISABLE FOR CITIPRO PLEASE CHANGE WITH ROLE ACCESS OR SUBSCRIPTION FEATURE
			if (_gHlp.isEmpty(product) || !_gHlp.isEmpty(product.prod_commission_at)) return false;
			//EXCLUDE FROM COMMISSION
			// if(!(['mortgage','property'].includes(product.prod_type))) return false;
			let status = null;
			let finalStatus = false;
			let list_status = [];
			let statusNames = [];
			let product_type = product.prod_type;
			if (product_type == 'property') {
				list_status = this.list_bank_statuses;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.bank_status_name);
				if (!_gHlp.isEmpty(product.product_banks) && !_gHlp.isEmpty(statusNames)) {
					finalStatus = product.product_banks.some(bank => statusNames.includes(bank.prod_bnk_stage_status));
				}

			} else if (product_type == 'mortgage') {
				list_status = this.list_mortgage_status;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.status);
				if (!_gHlp.isEmpty(product.product_banks) && !_gHlp.isEmpty(statusNames)) {
					finalStatus = product.product_banks.some(bank => statusNames.includes(bank.prod_bnk_stage_status));
				}

			} else if (product_type == 'personal_loan') {
				list_status = this.list_personal_loan_status;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.status);
				if (!_gHlp.isEmpty(product.product_banks) && !_gHlp.isEmpty(statusNames)) {
					finalStatus = product.product_banks.some(bank => statusNames.includes(bank.prod_bnk_stage_status));
				}

			} else if (product_type == 'refinance') {
				list_status = this.list_mortgage_status;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.status);
				if (!_gHlp.isEmpty(product.product_banks) && !_gHlp.isEmpty(statusNames)) {
					finalStatus = product.product_banks.some(bank => statusNames.includes(bank.prod_bnk_stage_status));
				}

			} else if (product_type == 'insurance') {
				list_status = this.list_insurance_status;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.status);
				if (!_gHlp.isEmpty(statusNames)) {
					finalStatus = statusNames.includes(product.prod_status);
				}

			} else if (product_type == 'other') {
				list_status = this.list_other_loan_status;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.status);
				if (!_gHlp.isEmpty(statusNames)) {
					finalStatus = statusNames.includes(product.prod_status);
				}
			} else if (product_type == 'mhlv') {
				list_status = this.list_mhlv_status;
				status = list_status.filter((item) => (item.is_generate_commission == 1));
				statusNames = status.map(status => status.status);
				if (!_gHlp.isEmpty(statusNames)) {
					finalStatus = statusNames.includes(product.prod_status);
				}
			}
			return finalStatus;
		},
		async submitSolicitorDocuments(formData) {
			let documents = {
				...formData,
			}
			try {
				const res = await axios.post(services.product + 'product-documents', documents, { headers: getHeader() })
				console.log('Product Updated Successfully')
			} catch (e) {
				console.log('Product Store (removeProduct) failed:' + e)
			}
		},
		sendEmailToBanker(bank, product, bank_documents = []) {
			if (!_gHlp.isEmpty(_gHlp.getValue(bank, 'prod_bnk_banker_detail.email', null)) && !_gHlp.isEmpty(bank_documents) && !_gHlp.isEmpty(product)) {
				let tat = _gHlp.isEmpty(_gHlp.getValue(bank, 'tat_summary.tat_stop_at')) ? _gHlp.getValue(bank, 'tat_summary.remain_day', 1) : _gHlp.getValue(bank, 'tat_summary.tat_total', 1);
				let prod_type = _gHlp.getValue(product, 'prod_type');

				let listProductDetailItems = [];
				switch (prod_type) {
					case 'property': {
						listProductDetailItems.push(_gHlp.getValue(product, 'product_detail.prod_pm_project_name') + ' SPA Price : RM.' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_spa_amount', 0)))
						listProductDetailItems.push('Loan Margin : ' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_margin', 0)) + '% (' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_loan_amount', 0)) + ')')
						break;
					}
					case 'mortgage': {
						listProductDetailItems.push(_gHlp.getValue(product, 'product_detail.prod_pm_project_name') + ' SPA Price : RM.' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_spa_amount', 0)))
						listProductDetailItems.push('Loan Margin : ' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_margin', 0)) + '% (' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_loan_amount', 0)) + ')')
						break;
					}
					case 'personal_loan': {
						listProductDetailItems.push('Personal Loan')
						listProductDetailItems.push('Loan Amount : ' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_loan_amount', 0)))
						break;
					}
					case 'refinance': {
						listProductDetailItems.push(_gHlp.getValue(product, 'product_detail.prod_ref_project_name'))
						listProductDetailItems.push('Loan Margin : ' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_margin', 0)) + '% (' + _gHlp.formatToMoney(_gHlp.getValue(bank, 'prod_bnk_loan_amount', 0)) + ')')
						break;
					}
					default:
						return false;
						break;
				}


				let listDocumentNames = [];
				let attcIds = [];
				if (!_gHlp.isEmpty(bank_documents)) {
					for (let i = 0; i < bank_documents.length; i++) {
						const att = bank_documents[i];
						listDocumentNames.push(_gHlp.getValue(att, 'attachment.filename'))
						attcIds.push(_gHlp.getValue(att, 'attachment.attachment_id'))
					}
				}

				let attrParams = {
					template_title: 'Submit To Banker',
					tat_label: 'TAT ' + tat + ' Days : ' + _gHlp.getValue(bank, 'prod_bnk_stage_status_label', 'Pending Acceptance'),
					customer_id: _gHlp.getValue(product, 'prod_customer_id'),
					customer_name: _gHlp.getValue(product, 'prod_customer_name'),
					ssa_name: _gHlp.getValue(product, 'prod_ssa_detail.name'),
					link_to_banker_login: '#',
					company_name: '-',
					company_position: '-',
					product_name: prod_type.replace('_', ' '),
					product_detail: '<ul><li>' + listProductDetailItems.join('</li><li>') + '</li></ul>',
					list_document: (!_gHlp.isEmpty(listDocumentNames)) ? '<ul><li>' + listDocumentNames.join('</li><li>') + '</li></ul>' : '<i>--no attachment--</i>',
				};
				let toEmail = _gHlp.getValue(bank, 'prod_bnk_banker_detail.email', null);

				console.log({ toEmail, attrParams, attcIds });
				useMessagingStore().sendEmailAttachment('CASE_SUBMIT_TO_BANKER', toEmail, attrParams, attcIds)
			}
		}
	}
})